import { render, staticRenderFns } from "./CardLalamove.vue?vue&type=template&id=4504ea97&scoped=true&"
import script from "./CardLalamove.vue?vue&type=script&lang=js&"
export * from "./CardLalamove.vue?vue&type=script&lang=js&"
import style0 from "./CardLalamove.vue?vue&type=style&index=0&id=4504ea97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504ea97",
  null
  
)

export default component.exports